import { createTheme, MantineColorsTuple } from "@mantine/core";

const haist: MantineColorsTuple = [
  "#EEF2FF",
  "#E0E7FF",
  "#C7D2FE",
  "#A5B4FC",
  "#818CF8",
  "#6366F1",
  "#4F46E5",
  "#4338CA",
  "#3730A3",
  "#312E81",
];

export const theme = createTheme({
  fontFamily:
    '"Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  fontFamilyMonospace:
    "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",

  colors: { haist },
  primaryColor: "haist",
  primaryShade: 5,

  defaultRadius: "md",
  cursorType: "pointer",
  focusRing: "never",
  respectReducedMotion: true,

  components: {
    Paper: {
      defaultProps: { shadow: "xs" },
    },
    Table: {
      defaultProps: { verticalSpacing: "sm", horizontalSpacing: "md" },
    },
    Button: {
      defaultProps: { radius: "md" },
    },
    TextInput: {
      defaultProps: { radius: "md" },
    },
    PasswordInput: {
      defaultProps: { radius: "md" },
    },
    Select: {
      defaultProps: { radius: "md" },
    },
    Textarea: {
      defaultProps: { radius: "md" },
    },
    NavLink: {
      styles: {
        root: { borderRadius: "var(--mantine-radius-md)" },
      },
    },
    Switch: {
      styles: {
        thumb: { backgroundColor: "white", borderColor: "white" },
      },
    },
    Pagination: {
      styles: {
        control: { border: "1px solid var(--mantine-color-gray-3)", color: "var(--mantine-color-dark-4)" },
      },
    },
    ActionIcon: {
      defaultProps: { variant: "subtle" },
    },
    Loader: {
      defaultProps: { type: "dots" },
    },
    Drawer: {
      defaultProps: { size: "78%" },
      styles: {
        content: {
          borderRadius: "var(--mantine-radius-md) 0 0 var(--mantine-radius-md)",
        },
      },
    },
  },
});

export const SIDEBAR_BG = "#ffffff";
export const SIDEBAR_WIDTH = 240;
// Width of the collapsed desktop nav rail (reopen button on top, gear on bottom).
export const RAIL_WIDTH = 64;
